/* Gio's Bazaar: site-wide motion. Everything is progressive: without this script (or with
   "reduce motion" on) the page simply shows in its final state. */
(() => {
  if (window.__gbMotion) return;
  window.__gbMotion = true;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const html = document.documentElement;
  html.classList.add('gb-motion');

  /* ---------- 1. Reveal sections and cards on scroll ---------- */
  const REVEAL = [
    '.gb-head', '.gb-pillars__head', '.gb-pillar', '.gb-card', '.gb-cgrid__group',
    '.gb-story__media', '.gb-story__copy', '.gb-metals__head', '.gb-metal-card',
    '.gb-faq__head', '.gb-faq__item', '.gb-foot__brand', '.gb-foot__cols > *',
    '.product-details .accordion', '.gb-tabs'
  ].join(',');
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        const shown = entries.filter((e) => e.isIntersecting).map((e) => e.target);
        shown.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top ||
          a.getBoundingClientRect().left - b.getBoundingClientRect().left);
        shown.forEach((el, i) => {
          el.style.setProperty('--gb-d', Math.min(i, 8) * 70 + 'ms');
          el.classList.add('gb-in');
          io.unobserve(el);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;
  const watch = (scope) => {
    scope.querySelectorAll(REVEAL).forEach((el) => {
      if (el.classList.contains('gb-reveal')) return;
      el.classList.add('gb-reveal');
      if (io) io.observe(el); else el.classList.add('gb-in');
    });
  };

  /* ---------- 5. Hero heading appears word by word ---------- */
  const hero = () => {
    const t = document.querySelector('.gb-hero__title');
    if (!t || t.dataset.gbWords) return;
    t.dataset.gbWords = '';
    const words = t.textContent.trim().split(/\s+/);
    t.setAttribute('aria-label', t.textContent.trim());
    t.innerHTML = words.map((w, i) =>
      '<span class="gb-word" aria-hidden="true" style="--w:' + i + '">' + w.replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' })[c]) + '</span>'
    ).join(' ');
    document.querySelector('.gb-hero')?.classList.add('gb-hero--in');
  };

  /* ---------- 3. Cart icon bounces when the count changes ---------- */
  const cartBounce = () => {
    document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
      if (el.dataset.gbWatch) return;
      el.dataset.gbWatch = '';
      let last = el.textContent.trim();
      let quietUntil = 0;
      new MutationObserver(() => {
        const now = el.textContent.trim();
        if (now === last) return;
        last = now;
        if (Date.now() < quietUntil) return;
        quietUntil = Date.now() + 1200;
        // Web Animations instead of classes: Horizon re-renders the icon when its classes change.
        const target = el.closest('.header-actions__cart-icon') || el.closest('.cart-bubble');
        target?.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.3)', offset: 0.35 }, { transform: 'scale(1)' }],
          { duration: 600, easing: 'cubic-bezier(0.3, 1.6, 0.5, 1)' }
        );
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  };

  // Safety net: anything already scrolled past (fast flicks, odd scroll containers) is shown too.
  let ticking = false;
  const sweep = () => {
    ticking = false;
    const limit = innerHeight * 0.95;
    document.querySelectorAll('.gb-reveal:not(.gb-in)').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < limit && (r.width || r.height)) {
        el.classList.add('gb-in');
        if (io) io.unobserve(el);
      }
    });
  };
  document.addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(sweep); }
  }, { capture: true, passive: true });
  window.addEventListener('load', () => setTimeout(sweep, 1500));

  const run = () => {
    watch(document);
    hero();
    cartBounce();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // Sections that Horizon re-renders (cart drawer, variant changes) get watched too.
  new MutationObserver((muts) => {
    for (const m of muts) for (const n of m.addedNodes) if (n.nodeType === 1) { watch(n); cartBounce(); }
  }).observe(document.body, { childList: true, subtree: true });
})();
